import { PASSWORD_RULES } from "@/lib/password";
import { Check, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  password: string;
  show: boolean;
}

export function PasswordRulesDisplay({ password, show }: Props) {
  if (!show) return null;

  return (
    <div className="bg-[#0a0e1a] border border-[#00ff00]/15 p-3 space-y-1.5">
      <div className="text-[#00ff00]/30 font-mono text-xs tracking-widest mb-2">PASSWORD REQUIREMENTS</div>
      {PASSWORD_RULES.map(rule => {
        const passed = rule.test(password);
        return (
          <div key={rule.id} className={cn(
            "flex items-center gap-2 font-mono text-xs transition-colors",
            passed ? "text-[#00ff00]" : "text-[#00ff00]/30"
          )}>
            {passed
              ? <Check className="w-3.5 h-3.5 shrink-0 text-[#00ff00]" />
              : <X className="w-3.5 h-3.5 shrink-0 text-[#00ff00]/20" />
            }
            {rule.label}
          </div>
        );
      })}
    </div>
  );
}
